import { ComponentProps } from 'react';

import { tailint } from '@pukka/common/utils';

import { Icon } from '../../Icon';
import { Text } from '../../Text';

const SIZES = tailint({
  xl: {
    container: 'p-4 gap-4',
    content: 'h-8 leading-8',
    variant: 'title-1',
    icon: 'lg',
    rounding: 'rounded-xl',
    option: {
      group: 'pt-4 pb-2',
      container: 'px-4',
      content: 'py-4 px-2 gap-4',
    },
  },
  l: {
    container: 'p-4 gap-4',
    content: 'h-6 leading-6',
    variant: 'subtitle-2',
    icon: 'lg',
    rounding: 'rounded-xl',
    option: {
      group: 'pt-4 pb-2',
      container: 'px-4',
      content: 'py-4 px-2 gap-4',
    },
  },
  m: {
    container: 'px-4 py-1.5 gap-2',
    content: 'h-6 leading-6',
    variant: 'body-2',
    icon: 'sm',
    rounding: 'rounded-md',
    option: {
      group: 'pt-2 pb-1',
      container: 'px-2',
      content: 'p-2 gap-2',
    },
  },
  s: {
    container: 'px-4 py-2 gap-2',
    content: 'h-4 leading-4',
    variant: 'body-1',
    icon: 'sm',
    rounding: 'rounded-md',
    option: {
      group: 'pt-2 pb-1',
      container: 'px-2',
      content: 'p-2 gap-2',
    },
  },
} satisfies {
  [k: string]: {
    container: string;
    content: string;
    icon: ComponentProps<typeof Icon>['size'];
    variant: ComponentProps<typeof Text>['variant'];
    rounding: string;
    option: {
      container: string;
      content: string;
      group: string;
    };
  };
});

export { SIZES };
